import {mapGetters, mapActions} from 'vuex';

// Constants
import * as PATIENT from '@/store/constants/patient';

// Mixins
import WithFilters from '@/mixins/with-filters';
import WithDateFilters from '@/mixins/with-date-filter';
import AuthUser from '@/mixins/authenticated-user';

// Modules.
import ListWithSpinner from '@/components/ListWithSpinner';
import SearchInput from '@/components/SearchInput';
import TableListActions from '@/components/TableListActions';
import TableRowActions from "@/components/TableRowActions";
import DownloadCsv from 'vue-json-csv'

export default {
  name: "PatientList",
  data() {
    return {
      fields: [
        {key: 'first_name', sortable: true},
        {key: 'last_name', sortable: true},
        "mobile",
        "gender",
        "address",
        {key: 'created_at', sortable: true},
        'action'
      ],
      isProcessing: false
    }
  },

  components: {ListWithSpinner, SearchInput, TableListActions, TableRowActions, DownloadCsv},

  mixins: [AuthUser, WithDateFilters, WithFilters],

  computed: {
    ...mapGetters({
      patients: PATIENT.GET_PATIENT_LIST
    }),

    items() {
      return this.patients.data || [];
    }
  },

  methods: {
    ...mapActions({
      listPatients: PATIENT.ACTION_LIST_PATIENTS
    }),

    viewDetail(item) {
      this.$router.push(
        {
          name: 'PatientDetail',
          params: {id: item.id, patient: item}
        }
      );
    },

    refreshData() {
      let filters = this.formatFilters();

      if (this.wildcard) {
        filters = {...filters, ...{wildcard: this.wildcard}};
      }

      filters = {
        ...filters, ...{
          page: this.patients.current_page || 1,
          order_by: [`created_at,desc`]
        }
      };

      this.isProcessing = true;
      this.listPatients(filters).then(() => this.isProcessing = false);
    },

    handlePaginate() {
      this.refreshData();
    },

    /**
     * Filter patient
     * @param item
     */
    filterPatient: window._.debounce(function (item) {
      this.wildcard = (item !== '') ? [`first_name|last_name,like,${item}`] : null;
      this.refreshData();
    }, 1000),

    /**
     * initialize items.
     */
    init() {
      this.refreshData();
    }
  },

  created() {
    this.init();
  }
}



// WEBPACK FOOTER //
// ./src/views/Patient/js/patient-list.js